/* Progressive enhancement: menu/search remain usable without JavaScript. */
(() => {
  function bind(root) {
    const header = root.matches?.('[data-dm-header]') ? root : root.querySelector?.('[data-dm-header]');
    if (!header || header.dataset.dmBound) return;
    header.dataset.dmBound = 'true';
    const disclosures = [...header.querySelectorAll('details[data-dm-disclosure]')];
    disclosures.forEach(details => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        disclosures.forEach(other => { if (other !== details) other.open = false; });
      });
      details.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        details.open = false;
        details.querySelector('summary')?.focus();
        event.stopPropagation();
      });
    });
    header.addEventListener('click', event => {
      if (event.target.closest('.dm-mobile-menu__panel a')) {
        disclosures.forEach(details => { details.open = false; });
      }
    });
    document.addEventListener('click', event => {
      if (!header.isConnected || header.contains(event.target)) return;
      disclosures.forEach(details => { details.open = false; });
    });
  }
  bind(document);
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();
